/**
 * MIRA RadioGroup Component
 * Wraps Shadcn RadioGroup with MIRA design system styles
 */

import React from 'react';
import { RadioGroup as ShadcnRadioGroup, RadioGroupItem as ShadcnRadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/radio-group.module.css';

export const RadioGroup = React.forwardRef(
  ({ className, isError, ...props }, ref) => {
    return (
      <ShadcnRadioGroup
        ref={ref}
        className={cn(styles.miraRadioGroup, className)}
        {...props}
      />
    );
  }
);

RadioGroup.displayName = 'MiraRadioGroup';

export const RadioGroupItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnRadioGroupItem
        ref={ref}
        className={cn(styles.miraRadioGroupItem, className)}
        {...props}
      />
    );
  }
);

RadioGroupItem.displayName = 'MiraRadioGroupItem';
